<template>
  <span class="inline-block shrink-0 overflow-hidden rounded-full bg-overlay" aria-hidden="true">
    <img src="/img/righty-light.jpg" alt="" class="size-full rounded-full object-cover dark:hidden" />
    <img src="/img/righty-dark.jpg" alt="" class="hidden size-full rounded-full object-cover dark:block" />
  </span>
</template>
